// removed by extract-text-webpack-plugin
module.exports = {"Loader":"_3ygdOIatWEAMqaJ9I13z3t","load7":"_2KfpuRDKqfxWtB8BxEyVlW"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/SingleLineSpinner/SingleLineSpinner.css
// module id = 329
// module chunks = 0